import ApiService from "../../api/api.service";
import JwtService from "../../common/jwt.service";
import CryptoJS, { PAYLOAD_AES_KEY } from "@/utils/cryptoLite";

var enable = true;
import {
  SET_AUTH,
  SET_ERROR,
  RESET_AUTH,
  CLEAR_ERRORS,
  UPDATE_USER_INFO,
  SET_PERMISSION_DATA,
} from "../mutations.type";

import {
  LOGIN,
  ADMIN_LOGIN,
  LOGOUT,
  ADMINLOGOUT,
  CHANGE_PASSWORD,
  SET_PROFILE_DATA,
  OTP_LOGIN,
  CHECK_AUTH,
  PERMISSION_DATA,
} from "../actions.type";

const getDefaultState = () => {
  return {
    token: null,
    userId: null,
    userType: null,
    otpUser: null,
    permissionData: null,
    loggedInPanel: JwtService.getTLoggedInPanel(),
    isAuthenticated: !!JwtService.getToken(),
  };
};

const state = getDefaultState();

const getters = {
  currentUser(state) {
    console.log("hello");
    return state.userId;
  },
  getCurrentUserPermission(state) {
    return state.permissionData;
  },
  getCurrentUserName(state) {
    return state.userId ? state.userId.first_name : null;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  getUserType(state) {
    return state.userType;
  },
  getUserLoggedInPanel(state) {
    return state.loggedInPanel;
  },
  getOtpVerificationUser(state) {
    return state.otpUser;
  },
  currentUserDesignation: (state) => {
    return state.userId ? state.userId.designation : null;
  },
};

const mutations = {
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.userId = data.userId;
    state.token = data.token_v1;
    state.errors = getDefaultState().errors;
    state.userType = data.userType;
    state.loggedInPanel = data.loggedInPanel;
    JwtService.setTLoggedInPanel(data.loggedInPanel);
    JwtService.setToken(data.token_v1);
    JwtService.setUserId(data.userId.id);
    JwtService.setUserType(data.userId.user_type_id);
    // Differential CSS: now authenticated → load the unpurged .full.css companions so dashboards
    // (dynamic runtime classes PurgeCSS can't see) render fully. Idempotent; defined in index.html.
    // Covers SPA-nav logins; reload-based logins (AdminLogin window.location.replace) are handled by
    // the index.html boot check on the fresh page load.
    if (typeof window !== "undefined" && window.__loadFullCss) window.__loadFullCss();
  },
  [SET_PROFILE_DATA](state, data) {
    state.userId = data.resultData.data;
  },
  [SET_PERMISSION_DATA](state, data) {
    state.permissionData = data.permissionData;
  },
  [RESET_AUTH](state) {
    JwtService.unsetToken();
    Object.assign(state, getDefaultState());
  },
  [UPDATE_USER_INFO](state, data) {
    state.userId = data;
  },
  [SET_ERROR](state, data) {
    state.otpUser = data.user;
  },
};

const actions = {
  [PERMISSION_DATA](context, credentials) {
    if (enable == true) {
      console.log(process.env.VUE_APP_ENCRYPTION, "encryption");
      let encJson = CryptoJS.AES.encrypt(JSON.stringify(credentials.data), PAYLOAD_AES_KEY).toString();
      credentials.data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    }
    return new Promise((resolve, reject) => {
      ApiService.post(credentials.api, credentials.data)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          if (!Boolean(data.success)) {
            context.commit(SET_ERROR, { message: data.message });
            reject(data);
          } else {
            context.commit(SET_PERMISSION_DATA, { permissionData: data });
            resolve(data);
          }
        })
        .catch(({ response }) => {
          console.log("Something went wrong");
        });
    }).catch((response) => {
      console.log("Something went wrong");
    });
  },
  [ADMIN_LOGIN](context, credentials) {
    if (enable == true) {
      console.log(process.env.VUE_APP_ENCRYPTION, "encryption");
      let encJson = CryptoJS.AES.encrypt(JSON.stringify(credentials.data), PAYLOAD_AES_KEY).toString();
      credentials.data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    }
    return new Promise((resolve, reject) => {
      ApiService.post(credentials.api, credentials.data)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          if (!Boolean(data.success)) {
            context.commit(SET_ERROR, { message: data.message });
            reject(data);
          } else {
            context.commit(SET_AUTH, {
              userId: data.user,
              token: data.token,
              userType: data.user.user_type_id,
              loggedInPanel: "admin",
            });
            resolve(data);
          }
        })
        .catch(({ response }) => {
          console.log("Something went wrong");
        });
    }).catch((response) => {
      console.log("Something went wrong");
    });
  },
  [LOGIN](context, credentials) {
    if (enable == true) {
      console.log(process.env.VUE_APP_ENCRYPTION, "encryption");
      let encJson = CryptoJS.AES.encrypt(JSON.stringify(credentials.data), PAYLOAD_AES_KEY).toString();
      credentials.data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    }
    return new Promise((resolve, reject) => {
      ApiService.post(credentials.api, credentials.data)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          if (!Boolean(data.success)) {
            context.commit(SET_ERROR, { message: data.message, user: data.user });
            reject(data);
          } else {
            if (data.user.user_type_id == 5) {
              var user_type = "jobseeker";
            } else if (data.user.user_type_id == 3 || data.user.user_type_id == 4) {
              var user_type = "employer";
            } else {
              var user_type = "admin";
            }
            context.commit(SET_AUTH, {
              userId: data.user,
              token: data.token,
              token_v1: data.token_v1,
              loggedInPanel:
                user_type /*, userType: data.user.user_type_id, loggedInPanel: 'company'*/,
            });
            resolve(data);
          }
        })
        .catch(({ response }) => {
          console.log("Something went wrong1");
        });
    }).catch((response) => {
      console.log("Something went wrong2", response);
    });
  },

  [LOGOUT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(credentials.api)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          context.commit(RESET_AUTH);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { message: response.data.error });
          reject(response);
        });
    });
  },

  [ADMINLOGOUT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(credentials.api)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          context.commit(RESET_AUTH);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { message: response.data.error });
          reject(response);
        });
    });
  },
  [CHECK_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("api/token-validate")
        .then(({ data }) => {
          if (!Boolean(data.success)) {
            context.commit(RESET_AUTH);
            reject(data);
            window.location.href = process.env.MIX_APP_URL;
          }
          resolve(data);
        })
        .catch(({ response }) => {
          console.log("Something went wrong");
        });
    } else {
      context.commit(RESET_AUTH);
    }
  },
  [OTP_LOGIN](context, credentials) {
    if (enable == true) {
      console.log(process.env.VUE_APP_ENCRYPTION, "encryption");
      let encJson = CryptoJS.AES.encrypt(JSON.stringify(credentials.data), PAYLOAD_AES_KEY).toString();
      credentials.data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    }
    return new Promise((resolve, reject) => {
      ApiService.post(credentials.api, credentials.data)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          if (!Boolean(data.success)) {
            context.commit(SET_ERROR, { message: data.message, user: data.user });
            reject(data);
          } else {
            if (data.user_type == 5) {
              context.commit(SET_RESULT_DATA, { resultData: data });
            } else {
              context.commit(SET_AUTH, {
                userId: data.user,
                token: data.token,
                userType: data.user.user_type_id,
                loggedInPanel: "company",
              });
            }
            resolve(data);
          }
        })
        .catch(({ response }) => {
          console.log("Something went wrong1");
        });
    }).catch((response) => {
      console.log("Something went wrong2", response);
    });
  },

  [CHANGE_PASSWORD](context, credentials) {
    if (enable == true) {
      console.log(process.env.VUE_APP_ENCRYPTION, "encryption");
      let encJson = CryptoJS.AES.encrypt(JSON.stringify(credentials.data), PAYLOAD_AES_KEY).toString();
      credentials.data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    }

    return new Promise((resolve, reject) => {
      ApiService.post(credentials.api, credentials.data)
        .then(({ data }) => {
          context.commit(CLEAR_ERRORS);
          if (!Boolean(data.success)) {
            context.commit(SET_ERROR, { message: data.message, user: data.user });
            reject(data);
          } else {
            context.commit(SET_AUTH, { userId: data.user, token: data.token });
            resolve(data);
          }
        })
        .catch(({ response }) => {
          console.log("Something went wrong");
        });
    }).catch((response) => {
      console.log("Something went wrong");
    });
  },
};

export default {
  getters,
  actions,
  mutations,
  state,
};
